<template>
  <div>
    <div
      v-if="s.popup == 'contactedit'"
      id="popnew"
      class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
    >
      <ContactEdit @close="closeContact" />
    </div>
    <div
      v-if="s.popup"
      @click="close"
      id="overlay"
      class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
    ></div>

    <template v-if="bid.id > 0 && canShowBid">
      <div class="flex max-xl:flex-col">
        <div class="w-[400px] my-4 max-xl:mx-auto max-xl:max-w-full">
          <div class="bg-white rounded-[4px]">
            <div class="p-4 v-bbgray">
              <div class="flex items-center w-full mb-4 relative">
                <h1 class="font-latobold text-xl text-black">ЗАЯВКА</h1>
              </div>
              <div class="flex items-center relative">
                <div class="w-16 h-16 relative">
                  <span
                    class="avatar w-full h-full flex items-center justify-center"
                    :class="{
                      'bg-status-1': bid.status == 1,
                      'bg-status-2': bid.status == 2,
                      'bg-status-6': bid.status == 3,
                      'bg-status-11': bid.status == 4 || bid.status == 6,
                    }"
                  >
                    <span
                      class="w-8 h-8 flex items-center justify-center first:!fill-white"
                    >
                      <IcoBidStatus :status="parseInt(bid.status)" />
                    </span>
                  </span>
                </div>
                <div class="flex flex-col ml-4 mr-8">
                  <span class="text-gray-400 text-[10px] uppercase">{{
                    st[bid.status]
                  }}</span>
                  <span class="font-latobold text-xl text-black"
                    >№{{ bid.id }}</span
                  >
                </div>
                <span
                  title="Обработка заявки просрочена"
                  v-if="bid.violate == 2"
                >
                  <svg class="w-5 h-5 -ml-6 mt-1 mr-4 fill-status-11">
                    <use xlink:href="@/assets/i.svg#status-11"></use>
                  </svg>
                </span>
                <div v-if="bid?.parent_id" class="flex items-center">
                  <div class="flex flex-col">
                    <p class="text-gray-400 text-[10px] uppercase">
                      Направление
                    </p>
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 1"
                      >Тахографы</span
                    >
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 2"
                      >Мониторинг</span
                    >
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 3"
                      >Карты</span
                    >
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 4"
                      >Пропуски</span
                    >
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 5"
                      >Обучение</span
                    >
                    <span
                      class="font-latobold text-xl text-gray-700"
                      v-if="bid.parent_id == 7"
                      >Водители</span
                    >
                    <!-- <span
                        v-if="bid.client?.business != 5"
                        class="font-latobold text-base text-gray-700"
                      >
                        {{ b[bid.client?.business] }}
                      </span>
                      <span v-else class="font-latobold text-base text-gray-700">
                        {{ bid.client?.business_dop }}
                      </span> -->
                  </div>
                </div>

                <div
                  v-if="bid.order_id"
                  class="absolute top-1 -right-4 h-14 overflow-hidden max-w-[40%] pl-6 pr-4 flex items-center"
                  @click="editOrderId(bid.order_id)"
                >
                  <svg class="w-7 h-7 fill-white z-2 mr-2">
                    <use xlink:href="@/assets/i.svg#ico-rating"></use>
                  </svg>
                  <span class="text-white z-20 relative text-2xl font-latobold"
                    >ЗАКАЗ</span
                  >
                  <svg
                    class="absolute top-0 -left-8 h-full"
                    :class="'!fill-status-6'"
                  >
                    <use xlink:href="@/assets/bg.svg#bg-timer"></use>
                  </svg>
                </div>

                <div
                  v-if="timer?.time"
                  class="absolute top-1 -right-4 h-14 overflow-hidden max-w-[50%] pl-6 pr-4 flex items-center"
                >
                  <span
                    class="text-white z-20 relative text-2xl font-latobold"
                    >{{ timer.time }}</span
                  >
                  <svg
                    class="absolute top-0 -left-8 h-full"
                    :class="'!fill-status-' + timer?.color"
                  >
                    <use xlink:href="@/assets/bg.svg#bg-timer"></use>
                  </svg>
                </div>
              </div>
            </div>

            <!-- <div class="flex p-5 v-bbgray">
                              <div class="flex items-center">
                                  <svg class="min-w-5 w-5 h-5 fill-gray-400 rotate-45 mr-2">
                                      <use xlink:href="@/assets/i.svg#ico-no"></use>
                                  </svg>
                                  <div class="flex flex-col">
                                      <span class="text-gray-400 text-[10px] uppercase">СОЗДАН</span>
                                      <span class="font-latobold text-base text-gray-700">{{
                                          moment(bid.create_at).format("DD.MM.YYYY в HH:mm")
                                      }}</span>
                                  </div>
                              </div>
                          </div> -->

            <div class="flex v-bbgray">
              <div class="flex py-5 pl-5 pr-4 items-center">
                <svg class="min-w-5 w-5 h-5 fill-gray-400 rotate-45 mr-2">
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
                <div class="flex flex-col">
                  <span class="text-gray-400 text-[10px] uppercase"
                    >СОЗДАН</span
                  >
                  <span class="font-latobold text-base text-gray-700">{{
                    moment(bid.created_at).format("DD.MM.YYYY в HH:mm")
                  }}</span>
                </div>
              </div>
            </div>
            <div v-if="bid.start_at" class="flex v-bbgray">
              <div class="flex ml-4 py-3 pl-5 pr-4 items-center">
                <div class="flex flex-col">
                  <span class="text-gray-400 text-[10px] uppercase"
                    >Начато</span
                  >
                  <span class="font-latobold text-base text-gray-700">{{
                    moment(bid.start_at).format("DD.MM.YYYY в HH:mm")
                  }}</span>
                </div>
              </div>
            </div>
            <div v-if="bid.end_at" class="flex v-bbgray">
              <div class="flex ml-4 py-3 pl-5 pr-4 items-center">
                <div class="flex flex-col">
                  <span class="text-gray-400 text-[10px] uppercase"
                    >Закончено</span
                  >
                  <span class="font-latobold text-base text-gray-700">{{
                    moment(bid.end_at).format("DD.MM.YYYY в HH:mm")
                  }}</span>
                </div>
              </div>
            </div>

            <!-- <div class="flex flex-wrap p-5 v-bbgray">
              <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                <input
                  class="mychbox"
                  type="checkbox"
                  id="taho"
                  v-model="bid.taho"
                  @change="kindOfLead({ name: 'taho', val: bid.taho })"
                />
                <label for="taho">Тахограф</label>
              </div>
              <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                <input
                  class="mychbox"
                  type="checkbox"
                  id="monitor"
                  v-model="bid.monitor"
                  @change="kindOfLead({ name: 'monitor', val: bid.monitor })"
                />
                <label for="monitor">Мониторинг</label>
              </div>
              <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                <input
                  class="mychbox"
                  type="checkbox"
                  id="card"
                  v-model="bid.card"
                  @change="kindOfLead({ name: 'card', val: bid.card })"
                />
                <label for="card">Карты</label>
              </div>
              <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                <input
                  class="mychbox"
                  type="checkbox"
                  id="propusk"
                  v-model="bid.propusk"
                  @change="kindOfLead({ name: 'propusk', val: bid.propusk })"
                />
                <label for="propusk">Пропуска</label>
              </div>
              <div class="w-1/3 flex flex-col px-4 my-2 max-m:w-full">
                <input
                  class="mychbox"
                  type="checkbox"
                  id="teach"
                  v-model="bid.teach"
                  @change="kindOfLead({ name: 'teach', val: bid.teach })"
                />
                <label for="teach">Обучение</label>
              </div>
            </div> -->
          </div>

          <!-- <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <div class="flex p-5 v-bbgray">
              <div class="flex flex-col justify-center overflow-hidden pr-8">
                <span
                  class="text-gray-400 leading-none w-full max-w-[300px] mr-6 mb-1"
                  >БИЗНЕС ПРОЦЕСС</span
                >
                <p
                  v-if="bid.business_proc"
                  class="font-latobold text-base text-gray-700"
                >
                  <span v-if="bid.business_proc == 1">
                    Пролонгация тахографы
                  </span>
                  <span v-if="bid.business_proc == 2">
                    Пролонгация настройки ЕСТР
                  </span>
                  <span v-if="bid.business_proc == 3">
                    Пролонгация пропуска
                  </span>
                  <span v-if="bid.business_proc == 4"> Пролонгация карты </span>
                  <span v-if="bid.business_proc == 5"> Контроль качества </span>
                  <span v-if="bid.business_proc == 6">
                    Реанимация неактивных клиентов
                  </span>
                  <span v-if="bid.business_proc == 7">
                    Реанимация клиентов без заказов
                  </span>
                  <span v-if="bid.business_proc == 8"> Рекламации </span>
                  <span v-if="bid.business_proc == 9"> Как дела </span>
                  <span v-if="bid.business_proc == 10"> Общий </span>
                  <span v-if="bid.business_proc == 11"> Контроль </span>
                </p>
                <p v-else class="font-latobold text-base text-red-400">
                  Бизнес процесс не выбран
                </p>
                                                
                                  <select v-model="bid.business_proc" class="select-bp v-bgray rounded-sm text-sm text-teal-700 w-full mt-2" name="" id="">
                                      <option value="0" disabled selected>Выберите опцию</option>
                                      <option value="1">Пролонгация тахографы</option>
                                      <option value="2">Пролонгация настройки ЕСТР</option>
                                      <option value="3">Пролонгация пропуска </option>
                                      <option value="4">Контроль качества</option>
                                      <option value="5">Реанимация неактивных клиентов</option>
                                      <option value="6">Реанимация клиентов без заказов</option>
                                      <option value="7">Рекламации</option>
                                      <option value="8">Агент</option>
                                  </select>

                <span class="font-latobold text-base text-gray-700">Старт касания</span>
              </div>
            </div>
          </div> -->
          <div v-if="bid.business_proc == 12" class="bg-white order-conn mt-4 p-5  relative rounded-[4px]">
            <div class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  Вид документа
                </p>
                <select
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="this.docType"
                  @change='sendDocument()'
                >
                  <option value="1" >
                    Счет на оплату
                  </option>
                </select>
              </div>
              <div class="flex items-center w-full mt-4">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  Номер документа
                </p>
                <input
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="this.docNumber"
                  placeholder="Введите номер документа"
                  type="text"
                  @focusout="sendDocument()"
                />
              </div>
          </div>

          <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <div v-if="bid.firm_id" class="flex p-5 v-bbgray">
              <div class="flex items-center group relative w-full">
                <div
                  class="flex flex-col justify-center overflow-hidden pr-8 w-full"
                >
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >Поставщик</span
                  >
                  <span class="font-latobold">{{ bid.firm_name }}</span>
                </div>
                <a
                  v-if="bid.status == 2"
                  class="group cursor-pointer opacity-0 group-hover:opacity-100"
                  @click="tryDelBidFirm()"
                >
                  <svg
                    class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                  >
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                </a>
              </div>
              <!-- <div
                v-if="bid.direction"
                class="flex items-center group relative w-1/2"
              >
                <div
                  class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <span
                    class="text-white text-xl w-11 h-11 leading-none rounded-full flex items-center justify-center"
                  >
                    <svg
                      class="w-5 h-5 fill-white"
                      :class="{ 'rotate-180': bid.direction == 2 }"
                    >
                      <use xlink:href="@/assets/i.svg#ico-next-one"></use>
                    </svg>
                  </span>
                </div>
                <div class="flex flex-col justify-center overflow-hidden pr-8">
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >НАПРАВЛЕНИЕ</span
                  >
                  <span class="font-latobold">{{
                    direction[bid.direction]
                  }}</span>
                </div>
                <a
                  class="group cursor-pointer opacity-0 group-hover:opacity-100"
                  @click="trySetLeadDirection(0)"
                >
                  <svg
                    class="fill-gray-400 w-4 h-4 mr-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                  >
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                </a>
              </div> -->
            </div>
            <div v-if="!bid.firm_id" class="p-5 v-bbgray">
              <div class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  Поставщик
                </p>
                <select
                  :disabled="bid.status == 1"
                  class="h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  v-model="bid.firm_id"
                  @change="trySetFirm(bid.firm_id)"
                >
                  <option :value="firm.id" v-for="firm in firms" :key="firm.id">
                    {{ firm.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <div class="flex p-5 v-bbgray">
              <div class="flex flex-col justify-center overflow-hidden pr-8">
                <span
                  class="text-gray-400 leading-none w-full max-w-[300px] mr-6 mb-1"
                  >БИЗНЕС ПРОЦЕСС</span
                >
                <p
                  v-if="bid.business_proc"
                  class="font-latobold text-base text-gray-700"
                >
                  <span v-if="bid.business_proc == 1">
                    Пролонгация тахографы
                  </span>
                  <span v-if="bid.business_proc == 2">
                    Пролонгация настройки ЕСТР
                  </span>
                  <span v-if="bid.business_proc == 3">
                    Пролонгация пропуска
                  </span>
                  <span v-if="bid.business_proc == 4"> Пролонгация карты </span>
                  <span v-if="bid.business_proc == 5"> Контроль качества </span>
                  <span v-if="bid.business_proc == 6">
                    Реанимация неактивных клиентов
                  </span>
                  <span v-if="bid.business_proc == 7">
                    Реанимация клиентов без заказов
                  </span>
                  <span v-if="bid.business_proc == 8"> Рекламации </span>
                  <span v-if="bid.business_proc == 9"> Как дела </span>
                  <span v-if="bid.business_proc == 10"> Общий </span>
                  <span v-if="bid.business_proc == 11"> АБ Мониторинг </span>
                  <span v-if="bid.business_proc == 12"> Агент </span>
                  <span v-if="bid.business_proc == 13"> Рекомендация </span>
                  <span v-if="bid.business_proc == 15"> Холодная база </span>
                </p>
                <p v-else class="font-latobold text-base text-red-400">
                  Бизнес процесс не выбран
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="canShowClient"
            class="rounded-[4px] bg-white mt-4 relative order-conn"
          >
            <template v-if="bid.client_id != null">
              <template v-if="bid.client?.loader">
                <div class="flex">
                  <img src="https://api.tahocrm.ru/images/loader.svg" />
                </div>
              </template>
              <template v-else>
                <div class="flex relative group miw-w-full p-5 v-bbgray">
                  <a
                    class="flex items-center cursor-pointer group max-w-[75%]"
                    @click="showClient(bid.client)"
                  >
                    <div
                      class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                    >
                      <span class="w-6 h-6 flex-cc">
                        <IcoPic
                          :pic="bid.client?.picture"
                          :name="bid.client?.name"
                        />
                      </span>
                    </div>
                    <div
                      class="flex flex-col justify-center overflow-hidden pr-8"
                    >
                      <span
                        class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                        >Клиент</span
                      >
                      <span
                        class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                        >{{ bid.client?.name }}</span
                      >
                    </div>
                  </a>

                  <!-- <div
                    v-if="
                      ['Manager', 'Studio' , 'Hosd'].includes(role) &&
                      [1, 2, 3, 10].includes(bid.status)
                    "
                    class="absolute top-1/2 -translate-y-1/2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-150"
                  >
                    <a class="cursor-pointer" @click="dClient">
                      <svg
                        class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                      >
                        <use xlink:href="@/assets/i.svg#ico-no"></use>
                      </svg>
                    </a>
                  </div> -->
                </div>
              </template>
            </template>

            <div v-else class="p-5">
              <div v-if="canEditClient" class="flex items-center w-full">
                <p class="text-gray-400 leading-none w-full max-w-[100px] mr-6">
                  КЛИЕНТ
                </p>
                <div class="flex-1 relative">
                  <input
                    type="text"
                    v-model.trim="text_client"
                    class="bg-slate-50 h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                    @click="findLeadClient(text_client)"
                    @input="findLeadClient(text_client)"
                  />
                  <div
                    class="absolute w-full top-full bg-white left-0 rounded-b-lg border border-green-500 border-t-0 z-10 hidden"
                    :class="{ '!block': selectLeadClients?.length > 0 }"
                  >
                    <div
                      v-for="cl in selectLeadClients"
                      :key="cl"
                      @click="setLeadClient(cl.id), (text_client = '')"
                      class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                    >
                      <span>{{ cl.name }}</span>
                      <span class="text-xs">{{ cl.iid }}</span>
                    </div>
                  </div>
                  <div
                    v-if="
                      text_client.length > 0 && selectLeadClients?.length <= 0
                    "
                    class="absolute w-full top-full bg-white left-0 rounded-b-lg border border-green-500 border-t-0 z-10 block"
                  >
                    <div
                      class="px-4 py-2 flex justify-between items-center hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                    >
                      <span>НЕ&nbsp;НАЙДЕН</span>
                      <button class="v-btn bg-green-500 hover:bg-green-400">
                        <span
                          class="v-btn_text flex items-center"
                          @click="
                            addLeadClient(text_client), (text_client = '')
                          "
                        >
                          <svg
                            class="fill-white w-16px h-16px mr-2 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linea"
                          >
                            <use xlink:href="/img/i.5cce8585.svg#ico-no"></use>
                          </svg>
                          СОЗДАТЬ
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <p v-else class="text-rose-400 leading-none text-center">
                Клиент не добавлен!
              </p>
            </div>

            <template v-if="bid.client_id != null">
              <div class="p-5 v-bbgray flex items-center group relative">
                <template v-if="bid.company_id != null">
                  <template v-if="bid.company?.loader">
                    <div class="flex">
                      <img src="https://api.tahocrm.ru/images/loader.svg" />
                    </div>
                  </template>
                  <template v-else>
                    <a
                      class="flex cursor-pointer group"
                      @click="showСompanyfromLead(bid.company)"
                    >
                      <div
                        class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                      >
                        <span class="w-6 h-6 flex-cc">
                          <IcoPic
                            :pic="bid.company?.picture"
                            :name="bid.company?.name"
                          />
                        </span>
                      </div>
                      <div
                        class="flex flex-col justify-center overflow-hidden pr-8"
                      >
                        <span
                          class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                          >Компания</span
                        >
                        <span
                          class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                        >
                          {{ bid.company?.secondname }}
                          {{ bid.company?.name }}
                        </span>
                      </div>
                    </a>
                    <div
                      v-if="
                        ['Manager', 'Assistant', 'Studio', 'Hosd'].includes(
                          role
                        ) &&
                        bid.company_id &&
                        [1, 2, 3, 10, 11, 12, 13].includes(bid.status)
                      "
                      class="absolute top-1/2 -translate-y-1/2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-150"
                    >
                      <a class="group cursor-pointer" @click="delBidCompany()">
                        <svg
                          class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                        >
                          <use xlink:href="@/assets/i.svg#ico-no"></use>
                        </svg>
                      </a>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div
                    v-if="
                      [
                        'Manager',
                        'Assistant',
                        'Logist',
                        'Studio',
                        'Hosd',
                        'Check',
                      ].includes(role) &&
                      selectBidCompanies &&
                      selectBidCompanies.length > 0
                    "
                    class="flex items-center w-full"
                  >
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      Выберите компанию
                    </p>
                    <div class="relative w-full">
                      <input
                        type="text"
                        v-model.trim="text_company"
                        class="bg-slate-50 h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                        @input="findCompany()"
                        @click="findCompany()"
                      />
                      <div
                        v-if="companyList && companyList.length > 0"
                        class="absolute w-full top-full bg-white left-0 border-2 border-green-800 border-t-0 z-10"
                      >
                        <div
                          v-for="co in companyList"
                          :key="co"
                          @click="pickCompany(co)"
                          class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                        >
                          <span>{{ co.secondname }} {{ co.name }}</span>
                          <span class="text-xs">{{ co.position }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-else class="text-rose-500 text-sm">
                    Компания не выбрана!
                  </p>
                </template>
              </div>

              <div class="p-5 v-bbgray flex items-center group relative">
                <template v-if="bid.contact_id != null">
                  <template v-if="bid.contact?.loader">
                    <div class="flex">
                      <img src="https://api.tahocrm.ru/images/loader.svg" />
                    </div>
                  </template>
                  <template v-else>
                    <a
                      class="flex cursor-pointer group"
                      @click="showContactfromLead(bid.contact)"
                    >
                      <div
                        class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                      >
                        <span class="w-6 h-6 flex-cc">
                          <IcoPic
                            :pic="bid.contact?.picture"
                            :name="bid.contact?.name.trim()"
                          />
                        </span>
                      </div>
                      <div
                        class="flex flex-col justify-center overflow-hidden pr-8"
                      >
                        <span
                          class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                          >Контакт</span
                        >
                        <span
                          class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                          >{{ bid.contact?.secondname }}
                          {{ bid.contact?.name }}</span
                        >
                      </div>
                    </a>
                    <template v-if="bid.contact?.phone">
                      <a
                        class="rounded-full absolute top-1/2 -translate-y-1/2 right-16 w-7 h-7 hover:w-40 overflow-hidden flex items-center bg-green-500 transition-all duration-300"
                        :href="'tel:' + bid.contact.phone"
                      >
                        <svg class="w-4 h-4 ml-[6px] fill-white">
                          <use xlink:href="@/assets/i.svg#ico-phone"></use>
                        </svg>
                        <span class="absolute left-7 p-1 text-white">{{
                          bid.contact?.phone
                        }}</span>
                      </a>
                    </template>
                    <div
                      v-if="
                        ['Manager', 'Assistant', 'Studio', 'Hosd'].includes(
                          role
                        ) &&
                        bid.contact_id &&
                        [1, 2, 3, 10, 11, 12, 13].includes(bid.status) &&
                        bid.status == 2
                      "
                      class="absolute top-1/2 -translate-y-1/2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-150"
                    >
                      <a class="group cursor-pointer" @click="delBidContact()">
                        <svg
                          class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                        >
                          <use xlink:href="@/assets/i.svg#ico-no"></use>
                        </svg>
                      </a>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div
                    v-if="
                      [
                        'Manager',
                        'Assistant',
                        'Logist',
                        'Studio',
                        'Hosd',
                        'Check',
                      ].includes(role) &&
                      selectBidContacts &&
                      selectBidContacts.length > 0
                    "
                    class="flex items-center w-full"
                  >
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      Выберите контакт
                    </p>
                    <div class="relative w-full">
                      <input
                        type="text"
                        v-model.trim="text_contact"
                        class="bg-slate-50 h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                        @input="findContact()"
                        @click="findContact()"
                      />
                      <div
                        v-if="contactList && contactList.length > 0"
                        class="absolute w-full top-full bg-white left-0 border-2 border-green-800 border-t-0 z-10"
                      >
                        <div
                          v-for="co in contactList"
                          :key="co"
                          @click="pickContact(co)"
                          class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                        >
                          <span>{{ co.secondname }} {{ co.name }}</span>
                          <span class="text-xs">{{ co.position }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-else class="text-rose-500 text-sm">
                    Контакт не добавлен!
                  </p>
                </template>
              </div>

              <!-- <div class="p-5 v-bbgray">
                <div v-if="bid.client?.ts" class="flex items-center">
                  <div class="flex flex-col">
                    <p class="text-gray-400 text-[10px] uppercase">КОЛ-ВО ТС</p>
                    <span class="font-latobold text-base text-gray-700">
                      {{ bid.client?.ts }}
                    </span>
                  </div>
                </div>
                <template v-else>
                  <div class="flex items-center w-full">
                    <p
                      class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                    >
                      КОЛ-ВО ТС <br />У КЛИЕНТА
                    </p>

                    <input
                      class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                      type="text"
                      v-model="ts"
                      @change="setClientTs(ts)"
                    />
                  </div>
                </template>
              </div> -->
            </template>
          </div>
          <div
            class="bg-white order-conn mt-4 p-5 relative rounded-[4px]"
            v-if="canAddClient"
          >
            <div style="position: relative" v-if="bid.client_id">
              <a
                @click="editNewClient"
                class="flex items-center cursor-pointer group max-w-[75%]"
              >
                <div
                  class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <span class="w-6 h-6 flex-cc">
                    <span
                      class="text-white text-xl w-11 h-11 leading-none rounded-full flex items-center justify-center"
                      >К</span
                    >
                  </span>
                </div>
                <div class="flex flex-col justify-center overflow-hidden pr-8">
                  <span
                    class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                    >Карточка клиента</span
                  >
                  <span
                    class="font-latobold text-base cursor-pointer group-hover:text-green-500 transition-colors duration-300"
                    >{{ bid?.client?.name }}</span
                  >
                </div>
              </a>
              <a
                class="cursor-pointer"
                style="position: absolute; right: 0; top: calc(50% - 8px)"
                @click="dClient"
              >
                <svg
                  class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                >
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </a>
            </div>

            <div v-else>
              <button
                @click="addNewClient"
                class="v-btn v-btn--sm bg-green-500 hover:bg-green-400"
              >
                <span class="v-btn_text flex items-center">
                  <svg
                    class="fill-white w-16px h-16px mr-3 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linear"
                  >
                    <use xlink:href="/img/i.cc1a44ec.svg#ico-no"></use>
                  </svg>
                  <span>Добавить клиента</span>
                </span>
              </button>
            </div>
            <div
              v-if="showClientEdit"
              id="popnew"
              class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
            >
              <ClientEdit @close="clientEditClose" />
            </div>
          </div>

          <div class="bg-white order-conn mt-4 relative rounded-[4px]">
            <div
              v-if="
                profile.uid == bid.manager_id ||
                [
                  'Manager',
                  'Assistant',
                  'Studio',
                  'Hosd',
                  'Finance',
                  'Check',
                ].includes(role)
              "
              class="flex relative group p-5 v-bbgray"
            >
              <div v-if="bid.manager_id" class="flex justify-between">
                <div class="flex items-center cursor-pointer group">
                  <div
                    class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 overflow-hidden bg-green-500"
                  >
                    <span class="w-6 h-6">
                      <IcoPic :pic="bid.mpicture" :name="bid.mname" />
                    </span>
                  </div>
                  <div
                    class="flex flex-col justify-center overflow-hidden pr-8"
                  >
                    <span
                      class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                      >Менеджер</span
                    >
                    <span
                      class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                      >{{ bid.mname }} {{ bid.msecondname }}</span
                    >
                  </div>
                </div>
                <!-- <div
                  v-if="bid.manager_id && [1, 3].includes(bid.status)"
                  class="absolute top-1/2 -translate-y-1/2 right-8 opacity-0 group-hover:opacity-100 transition-all duration-150"
                >
                  <a class="group cursor-pointer" @click="delLeadManager()">
                    <svg
                      class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                    >
                      <use xlink:href="@/assets/i.svg#ico-no"></use>
                    </svg>
                  </a>
                </div> -->
              </div>

              <template v-else>
                <div class="flex items-center w-full">
                  <p
                    class="text-gray-400 leading-none w-full max-w-[100px] mr-6"
                  >
                    Менеджер
                  </p>
                  <div class="relative w-full">
                    <input
                      type="text"
                      v-model.trim="text_manager"
                      class="bg-white h-9 px-3 py-2 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                      @input="findManager()"
                      @click="findManager()"
                    />
                    <div
                      v-if="managerList.length"
                      class="absolute w-full top-full bg-white left-0 border-2 border-green-800 border-t-0 z-10"
                    >
                      <div
                        v-for="m in managerList"
                        :key="m"
                        @click="setLeadManager(m)"
                        class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                      >
                        <span>{{ m.secondname }} {{ m.name }}</span>
                        <span class="text-xs">{{ m.uid }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="flex relative group p-5 v-bbgray">
              <div v-if="bid.who" class="flex justify-between">
                <div class="flex items-center cursor-pointer group">
                  <div
                    class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 overflow-hidden bg-green-500"
                  >
                    <span class="w-6 h-6">
                      <IcoPic :pic="bid.wpicture" :name="bid.wname" />
                    </span>
                  </div>
                  <div
                    class="flex flex-col justify-center overflow-hidden pr-8"
                  >
                    <span
                      class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                      >СОЗДАТЕЛЬ</span
                    >
                    <span
                      class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                      >{{ bid.wname }} {{ bid.wsecondname }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col ml-4 mr-12 flex-1 mb-4 max-l:mx-0">
          <div
            v-if="
              profile.uid == bid.manager_id ||
              ([
                'Manager',
                'Logist',
                'Studio',
                'Hosd',
                'Finance',
                'Assistant',
                'Check',
              ].includes(role) &&
                canShowGar)
            "
            class="flex justify-between border-t-2 border-gray-400 w-[90%] mt-10 mb-1 mx-auto max-m:hidden"
          >
            <div class="flex flex-col items-center -mt-6 -ml-6 relative">
              <span
                @click="toggleGarl('showTouches')"
                class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#nav-clients"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >КАСАНИЕ</span
              >

              <div
                v-if="showTouches && garland.touches.length > 0"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">Касания</p>
                <a
                  v-for="touch in garland.touches"
                  :key="touch"
                  @click="goToTouch(touch.id)"
                  >№{{ touch.id }}</a
                >
              </div>
            </div>
            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showLeads')"
                class="rounded-full h-11 w-11 bg-gray-400 flex items-center justify-center"
                :class="{
                  '!bg-status-5': garland.leads.length > 0,
                  '!bg-status-7': bid.status == 4,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#status-1"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЛИД</span
              >
              <div
                v-if="showLeads && garland.leads.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Лиды из касания
                </p>
                <a
                  @click="goToLead(lead.id)"
                  v-for="lead in garland.leads"
                  :key="lead"
                  >№{{ lead.id }}</a
                >
              </div>
              <!-- 
                          <div v-if="showLeads && garland.leads.length > 0" class="absolute-list">
                              <p class='font-latobold text-base text-gray-700'>Лиды из касания</p>
                              <a v-for="lead in garland.leads" :key="lead">№{{ bid.iid }}</a>
                          </div> -->
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showZayavka')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-1': bid.status == 1,
                  '!bg-status-2': bid.status == 2,
                  '!bg-status-5': bid.status == 3,
                  '!bg-status-7': bid.status == 4,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#doc"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЗАЯВКА</span
              >
              <!-- <div
              v-if="showZayavka && garland.bids.length"
              class="absolute-list"
            >
              <p class="font-latobold text-base text-gray-700">
                Заявки из касания
              </p>
              <a v-for="bid in garland.bids" :key="bid">№{{ bid.id }}</a>
            </div> -->
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showSchet')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.invoices.length,
                  '!bg-status-7': bid.status == 4,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#doc"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >СЧЕТ</span
              >

              <div
                v-if="showSchet && garland.invoices.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Счета из касания
                </p>
                <a
                  v-for="invoice in garland.invoices"
                  @click="goToInvoice(invoice.id)"
                  :key="invoice"
                  >{{ invoice.invoice_number }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 relative">
              <span
                @click="toggleGarl('showOrderLet')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.orders.length,
                  '!bg-status-7': bid.status == 4,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#pay-1"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >ЗАКАЗ</span
              >
              <div
                v-if="showOrderLet && garland.orders.length"
                class="absolute-list last-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Заказы из касания
                </p>
                <a
                  v-for="order in garland.orders"
                  @click="goToOrder(order.id)"
                  :key="order"
                  >№{{ order.iid }}</a
                >
              </div>
            </div>

            <div class="flex flex-col items-center -mt-6 -mr-6 relative">
              <span
                @click="toggleGarl('showAnketa')"
                class="rounded-full h-11 w-11 flex items-center justify-center bg-gray-400"
                :class="{
                  '!bg-status-5': garland.anketas.length,
                  '!bg-status-7': bid.status == 4,
                }"
              >
                <svg class="w-5 h-5 fill-white">
                  <use xlink:href="@/assets/i.svg#pay-2"></use>
                </svg>
              </span>
              <span
                class="text-[10px] text-gray-400 leading-none uppercase mt-1"
                >АНКЕТА</span
              >

              <div
                v-if="showAnketa && garland.anketas.length"
                class="absolute-list"
              >
                <p class="font-latobold text-base text-gray-700">
                  Анкеты из касания
                </p>
                <a v-for="anketa in garland.anketas" :key="anketa"
                  >№{{ anketa.id }}</a
                >
              </div>
            </div>
          </div>

          <!-- <div class="p-5 bg-white rounded-[4px] mt-4">
            
          </div> -->

          <!-- <div class="p-5 bg-white rounded-[4px] mt-4">
                          <div class="flex items-center max-l:flex-wrap">
                              <div class="flex items-center max-l:flex-wrap">
                                  <span class="text-base font-latobold uppercase">Событие в 1С</span><br/>
                                  <div class="flex items-center w-full">
                                      <textarea
                                          class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                                          v-model="bid.event_one_s"
                                          @change="setEvent1S(bid.event_one_s)"
                                      ></textarea>
                                  </div>
                              </div>
                          </div>
                      </div> -->

          <div class="bg-white rounded-[4px] mt-4">
            <template v-if="bid.price">
              <div
                v-for="p in bid.price"
                :key="p"
                class="flex p-5 items-center v-bbgray justify-between"
              >
                <template v-if="p.loader">
                  <div class="flex">
                    <img src="https://api.tahocrm.ru/images/loader.svg" />
                  </div>
                </template>
                <template v-else>
                  <template
                    v-if="
                      [
                        'Manager',
                        'Logist',
                        'Finance',
                        'Assistant',
                        'Studio',
                        'Hosd',
                        'Finance',
                      ].includes(role)
                    "
                  >
                    <div class="max-w-[50%] w-full flex items-center">
                      <span
                        class="rounded-full h-11 min-w-[2.75rem] w-11 bg-status-1 flex items-center justify-center mr-4 overflow-hidden"
                      >
                        <svg class="w-5 h-5 fill-white">
                          <use xlink:href="@/assets/i.svg#nav-service"></use>
                        </svg>
                      </span>
                      <span class="text-base font-latobold">{{
                        p.price.name
                      }}</span>
                    </div>

                    <div class="flex items-center">
                      <!-- <svg class="w-5 h-5 mr-4">
                        <use xlink:href="@/assets/i.svg#ico-timer"></use>
                      </svg>
                      <div class="text-base font-latobold">
                        {{ p.price.time }}
                      </div> -->
                    </div>

                    <div class="flex text-base font-latobold w-24">
                      <div
                        v-if="
                          p.items > 1 &&
                          (role == 'Manager' ||
                            role == 'Studio' ||
                            role == 'Hosd' ||
                            role == 'Assistant' ||
                            role == 'Finance') &&
                          bid.status == 2
                        "
                        @click="
                          setCountBidPrice({
                            price_id: p.id,
                            sum: p.cost,
                            items: p.items - 1,
                          })
                        "
                        style="line-height: 30px"
                        class="text-green-500 text-xl cursor-pointer mr-2"
                      >
                        -
                      </div>
                      <span style="line-height: 30px">{{ p.items }} шт</span>
                      <div
                        v-if="
                          (role == 'Manager' ||
                            role == 'Studio' ||
                            role == 'Hosd' ||
                            role == 'Assistant' ||
                            role == 'Finance') &&
                          bid.status == 2
                        "
                        @click="
                          setCountBidPrice({
                            price_id: p.id,
                            sum: p.cost,
                            items: p.items + 1,
                          })
                        "
                        style="line-height: 30px"
                        class="text-green-500 text-xl cursor-pointer ml-2"
                      >
                        +
                      </div>
                    </div>

                    <div class="text-base font-latobold w-24" v-if="p.cost > 0">
                      {{ p.cost }} ₽
                    </div>
                    <div class="text-base font-latobold w-24" v-else>
                      цена неизвестна
                    </div>

                    <template
                      v-if="
                        (role == 'Manager' ||
                          role == 'Studio' ||
                          role == 'Hosd' ||
                          role == 'Assistant' ||
                          role == 'Finance') &&
                        bid.status == 2
                      "
                    >
                      <div class="flex">
                        <a
                          class="mr-4 group cursor-pointer"
                          @click="(s.popup = 'price'), (editPrice = p)"
                        >
                          <svg
                            class="fill-gray-400 w-4 h-4 group-hover:fill-green-500 transition-colors duration-300"
                          >
                            <use xlink:href="@/assets/i.svg#ico-edit"></use>
                          </svg>
                        </a>

                        <a class="group cursor-pointer" @click="delBidPrice(p)">
                          <svg
                            class="fill-gray-400 w-4 h-4 group-hover:fill-rose-500 transition-colors duration-300"
                          >
                            <use xlink:href="@/assets/i.svg#ico-no"></use>
                          </svg>
                        </a>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="flex items-center">
                      <span
                        class="rounded-full h-11 min-w-[2.75rem] w-11 bg-status-1 flex items-center justify-center mr-4 overflow-hidden"
                      >
                        <svg class="w-5 h-5 fill-white">
                          <use xlink:href="@/assets/i.svg#nav-service"></use>
                        </svg>
                      </span>
                      <span class="text-base font-latobold">{{
                        p.price.name
                      }}</span>
                    </div>
                  </template>
                </template>
              </div>
            </template>

            <template
              v-if="
                (role == 'Manager' ||
                  role == 'Studio' ||
                  role == 'Hosd' ||
                  role == 'Finance' ||
                  role == 'Assistant') &&
                (bid.status == 2 || bid.status == 6)
              "
            >
              <div class="p-5 v-bbgray flex items-center">
                <p class="text-gray-400 leading-none max-w-[25%] w-full">
                  Добавить услугу
                </p>
                <div class="flex flex-1 h-9 relative">
                  <input
                    :disabled="bid.status == 1"
                    type="text"
                    v-model.trim="text_price"
                    class="w-full bg-white v-bgray"
                    @input="findPrice"
                    @click="findPrice"
                  />
                  <div
                    v-if="priceList.length"
                    class="absolute max-h-[350px] overflow-y-auto w-full top-full bg-white left-0 border-2 border-green-800 border-t-0"
                  >
                    <div
                      v-for="p in priceList"
                      :key="p.id"
                      @click="pickPrice(p)"
                      class="px-4 py-2 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                    >
                      <span>{{ p.name }}</span>
                      <span class="text-xs">{{ p.sum }}₽</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <template v-if="bid.codebill">
                <template v-if="bid.pay > 0">
                  <template v-if="bid.pay_status == 6">
                    <div class="flex p-5 items-center v-bbgray justify-between">
                      <p class="text-gray-400 leading-none max-w-[25%] w-full">
                        Дата оплаты
                      </p>
                      <span
                        v-if="bid.pay_date"
                        class="text-base font-latobold mr-8"
                      >
                        {{ moment(bid.pay_date).format("DD.MM.YYYY") }}
                      </span>

                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 1"
                        >Наличные взять</span
                      >
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 2"
                      >
                        Наличные предоплата
                      </span>
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 4"
                        >Безнал предоплата</span
                      >
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 7"
                        >С отсрочкой</span
                      >
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex p-5 items-center v-bbgray justify-between">
                      <p class="text-gray-400 leading-none max-w-[25%] w-full">
                        Дата ожидаемой оплаты
                      </p>
                      <span
                        v-if="bid.pay_wait"
                        class="text-base font-latobold mr-8"
                      >
                        {{ moment(bid.pay_wait).format("DD.MM.YYYY") }}
                      </span>

                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 1"
                        >Наличные взять</span
                      >
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 2"
                      >
                        Наличные предоплата
                      </span>
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 4"
                        >Безнал предоплата</span
                      >
                      <span
                        class="text-base font-latobold"
                        v-if="bid.pay == 7"
                        >С отсрочкой</span
                      >

                      <a class="group cursor-pointer" @click="setOrderPay(0)">
                        <svg
                          class="fill-gray-400 w-4 h-4 group-hover:fill-rose-500 transition-colors duration-300"
                        >
                          <use xlink:href="@/assets/i.svg#ico-no"></use>
                        </svg>
                      </a>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="flex px-5 py-3 items-center max-l:flex-wrap">
                    <div class="flex justify-center flex-wrap max-l:w-full">
                      <a
                        class="w-max v-btn v-btn--md bg-green-500 hover:bg-green-400 m-2"
                        :class="{
                          '!bg-gray-500 hover:!bg-gray-400': bid.pay != 1,
                        }"
                        @click="setOrderPay(1)"
                      >
                        <span class="v-btn_text flex items-center">
                          <svg class="fill-white w-16px h-16px mr-3">
                            <use xlink:href="@/assets/i.svg#pay-1"></use>
                          </svg>
                          <span>Наличные взять</span>
                        </span>
                      </a>
                      <a
                        class="w-max v-btn v-btn--md bg-green-500 hover:bg-green-400 m-2"
                        :class="{
                          '!bg-gray-500 hover:!bg-gray-400': bid.pay != 4,
                        }"
                        @click="setOrderPay(4)"
                      >
                        <span class="v-btn_text flex items-center">
                          <svg class="fill-white w-16px h-16px mr-3">
                            <use xlink:href="@/assets/i.svg#pay-2"></use>
                          </svg>
                          <span>Безнал предоплата</span>
                        </span>
                      </a>
                      <a
                        class="w-max v-btn v-btn--md bg-green-500 hover:bg-green-400 m-2"
                        :class="{
                          '!bg-gray-500 hover:!bg-gray-400': bid.pay != 2,
                        }"
                        @click="setOrderPay(2)"
                      >
                        <span class="v-btn_text flex items-center">
                          <svg class="fill-white w-16px h-16px mr-3">
                            <use xlink:href="@/assets/i.svg#pay-1"></use>
                          </svg>
                          <span>Наличные предоплата</span>
                        </span>
                      </a>
                      <a
                        class="w-max v-btn v-btn--md bg-green-500 hover:bg-green-400 m-2"
                        :class="{
                          '!bg-gray-500 hover:!bg-gray-400': bid.pay != 7,
                        }"
                        @click="setOrderPay(7)"
                      >
                        <span class="v-btn_text flex items-center">
                          <svg class="fill-white w-16px h-16px mr-3">
                            <use xlink:href="@/assets/i.svg#pay-3"></use>
                          </svg>
                          <span>С отсрочкой</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </template>
              </template> -->
            </template>

            <div class="flex p-5 v-bbgray justify-between items-center max-l:flex-wrap">
              <div class="max-w-[50%] w-full flex items-center">
                <span
                  class="rounded-full h-11 min-w-[2.75rem] w-11 font-latobold text-xl text-white bg-status-1 flex items-center justify-center mr-4 overflow-hidden"
                >
                  ₽
                </span>
                <span class="text-base font-latobold">СУММА ЗАЯВКИ</span>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-base font-latobold mr-28">
                  всего услуг - {{ bid.price_items }} шт.
                </div>
                <div class="text-base font-latobold mr-8">{{ bid.sum }} ₽</div>
              </div>
            </div>
            <div v-if="bid.business_proc == 12" class="p-5 bg-white rounded-[4px]">
            <div class="flex justify-between items-center max-l:flex-wrap">
              <div class="max-w-[50%] w-full flex items-center">
                <span
                  class="rounded-full h-11 min-w-[2.75rem] w-11 font-latobold text-xl text-white bg-status-1 flex items-center justify-center mr-4 overflow-hidden"
                >
                  ₽
                </span>
                <span class="text-base font-latobold">СУММА БОНУСА</span>
              </div>
              <div v-if="bid.agent_sum" class="flex justify-between items-center">
                <div class="text-base font-latobold">{{ bid.agent_sum }}&nbsp;₽</div>
                <a
                  class="group cursor-pointer ml-4"
                  @click="setAgentSum(0), (agentSum = 0)"
                >
                  <svg
                    class="fill-gray-400 w-4 h-4 group-hover:fill-rose-500 transition-colors duration-300"
                  >
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                </a>
              </div>

              <template v-else>
                <div class="flex items-center w-full">
                  <!-- :disabled="lead.status == 1" -->
                  <input
                    class="h-9 px-3 py-2 mt-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                    :class="{'attention': this.bid.agent_sum == 0 || this.bid.agent_sum == null || this.bid.agent_sum == undefined || this.bid.agent_sum == ''}"
                    type="text"
                    placeholder="Введите сумму!"
                    v-model="agentSum"
                    @change="setAgentSum(agentSum)"
                  />
                </div>
              </template>
            </div>
          </div>
          </div>

          <div class="double-flex">
            <div class="w-[100%] p-5 bg-white rounded-[4px] mt-4">
              <div class="flex items-center max-l:flex-wrap">
                <div class="flex items-center max-l:flex-wrap">
                  <span
                    class="rounded-full h-11 min-w-[2.75rem] w-11 bg-green-500 flex items-center justify-center mr-4"
                  >
                    <svg class="fill-white w-5 h-5">
                      <use xlink:href="@/assets/i.svg#ico-timer"></use>
                    </svg>
                  </span>
                  <span class="text-base font-latobold uppercase"
                    >Задачи:
                  </span>
                  <div
                    v-for="item in bid.tasks"
                    :key="item"
                    class="preview ml15"
                  >
                    <a
                      class="ml-2 text-base font-latobold cursor-pointer hover:text-green-500 transition-colors duration-300"
                      :class="statusClasses[item.status]"
                      @click="showTask(item)"
                      >№{{ item.iid }}</a
                    >
                  </div>
                </div>

                <button
                  v-if="bid.status != 1"
                  class="v-btn v-btn--sm bg-green-500 hover:bg-green-400 ml-auto"
                >
                  <span
                    class="v-btn_text flex items-center"
                    @click="
                      tryAddTask({
                        object: 'bid',
                        oid: bid.id,
                        type: 105,
                        department: 1,
                      })
                    "
                  >
                    <svg
                      class="fill-white w-16px h-16px mr-3 rotate-45 group-hover:-rotate-45 duration-100 transition ease-linear"
                    >
                      <use xlink:href="@/assets/i.svg#ico-no"></use>
                    </svg>
                    <span>ЗАДАЧА</span>
                  </span>
                </button>
              </div>
            </div>

            <!-- <div class="w-[50%] ml-2 p-5 bg-white rounded-[4px] mt-4">
              <div class="flex items-center max-l:flex-wrap">
                <div class="flex items-center max-l:flex-wrap">
                  <span
                    class="rounded-full h-11 min-w-[2.75rem] w-11 bg-blue-500 flex items-center justify-center mr-4"
                  >
                    <svg class="fill-white w-5 h-5">
                      <use xlink:href="@/assets/i.svg#ico-phone"></use>
                    </svg>
                  </span>
                  <span class="text-base font-latobold uppercase"
                    >Телефония:
                  </span>
                  <span class="text-base font-latobold uppercase ml-4"
                    >8 800 000 00 00</span
                  >
                </div>
              </div>
            </div> -->
          </div>
          <div class="p-5 bg-white mt-4 rounded-[4px]">
            <CommentList
              :id="parseInt(bid.id)"
              :iid="parseInt(bid.iid)"
              type="bid"
            />
          </div>

          <div
            v-if="otkaz || bid.status == 4"
            class="p-5 bg-white mt-4 rounded-[4px]"
          >
            <div v-if="bid.status == 4" class="flex items-center">
              <div
                class="min-w-[1.5rem] w-7 h-7 rounded-full bg-rose-500 flex items-center justify-center mr-4"
              >
                <svg class="w-4 h-4 fill-white">
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </div>
              <div>
                <span class="blocktext-xs text-gray-800 font-latobold">{{
                  cancel[bid.cancel_id]
                }}</span>
                <span
                  v-if="bid.comment"
                  class="blocktext-xs text-gray-800 font-latobold block"
                  >{{ bid.comment }}</span
                >
              </div>
            </div>

            <div v-else class="flex flex-col justify-center">
              <h3 class="text-red-500 text-center">Укажите причину отказа</h3>
              <select
                class="w-full px-4 py-2 bg-white v-bgray rounded-md mb-3"
                v-model="cancel_id"
              >
                <option value="0" disabled selected>Выбрать причину</option>
                <option :value="key" v-for="(val, key) in cancel" :key="val">
                  {{ val }}
                </option>
              </select>
              <textarea
                type="text"
                class="w-full px-4 py-2 bg-white v-bgray rounded-md"
                v-model="bid.comment"
                placeholder="Комментарий"
              ></textarea>
              <button
                v-if="parseInt(cancel_id) > 0"
                class="v-btn v-btn--sm v-btn--sm bg-green-500 hover:bg-green-400 ml-auto mt-3"
                @click="
                  sendBidCancel({ cancel_id: cancel_id, comment: bid.comment })
                "
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-16px h-16px mr-3">
                    <use xlink:href="@/assets/i.svg#ico-telegram"></use>
                  </svg>
                  <span>ОТПРАВИТЬ</span>
                </span>
              </button>
            </div>
          </div>

          <div class="flex justify-around mt-4">
            <template
              v-if="
                ['Manager', 'Studio', 'Hosd', 'Assistant'].includes(role) &&
                ![1].includes(bid.status) &&
                ![3].includes(bid.status) &&
                ![4].includes(bid.status) &&
                bid.price.length > 0
              "
            >
              <!-- <button class="v-btn v-btn--sm bg-emerald-600 hover:bg-emerald-500"> -->
              <button
                class="v-btn v-btn--sm bg-emerald-600 hover:bg-emerald-500"
                @click="tryCreateInvoice"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#nav-flow"></use>
                  </svg>
                  <span>Создать счет</span>
                </span>
              </button>
            </template>

            <template
              v-if="
                ['Manager', 'Studio', 'Hosd', 'Assistant'].includes(role) &&
                ![1].includes(bid.status) &&
                ![4].includes(bid.status) &&
                !otkaz
              "
            >
              <button
                class="v-btn v-btn--sm bg-gray-400 hover:bg-gray-300"
                @click="tryCansel"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#ico-no"></use>
                  </svg>
                  <span>Отказ</span>
                </span>
              </button>
            </template>

            <template
              v-if="
                ['Manager', 'Studio', 'Hosd', 'Assistant'].includes(role) &&
                [1].includes(bid.status)
              "
            >
              <!-- <button class="v-btn v-btn--sm bg-emerald-600 hover:bg-emerald-500"> -->
              <button
                @click="startBidFunc()"
                class="v-btn v-btn--sm bg-emerald-600 hover:bg-emerald-500"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#nav-flow"></use>
                  </svg>
                  <span>Начать</span>
                </span>
              </button>
            </template>

            <!-- <template
              v-if="
                ['Manager', 'Studio' , 'Hosd'].includes(role) &&
                ![8, 11].includes(bid.status) &&
                !otkaz
              "
            >
              <button
                class="v-btn v-btn--sm bg-rose-500 hover:bg-rose-400"
                @click="tryDelLead"
              >
                <span class="v-btn_text flex items-center">
                  <svg class="fill-white w-4 h-4 mr-3">
                    <use xlink:href="@/assets/i.svg#ico-delete"></use>
                  </svg>
                  <span>Удалить</span>
                </span>
              </button>
            </template> -->
          </div>
        </div>
      </div>

      <div
        v-if="s.popup == 'task'"
        id="popnew"
        class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-max overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
      >
        <TaskEdit @close="close" />
      </div>

      <div
        v-if="s.popup"
        @click="close"
        id="overlay"
        class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
      ></div>

      <div
        v-if="s.popup == 'price'"
        id="popnew"
        class="w-2/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
      >
        <a
          class="flex items-center bg-gray-500 px-4 py-2 absolute top-0 right-0 rounded-close cursor-pointer hover:bg-gray-400 transition-colors duration-150"
          @click="s.popup = false"
        >
          <span class="text-white mr-2">Закрыть</span>
          <svg class="fill-white w-4 h-4">
            <use xlink:href="@/assets/i.svg#ico-no"></use>
          </svg>
        </a>
        <div class="flex text-center my-8 flex-col px-4">
          <h3 class="text-lg text-black">Изменить стоимость услуги</h3>

          <div class="flex flex-col">
            <div class="flex flex-col items-center mt-6">
              <span class="text-gray-400 leading-none">Текущая стоимость</span>
              <span class="text-black text-lg"
                >{{ editPrice.cost }}&nbsp;&#8381;</span
              >
            </div>

            <div class="flex justify-around mt-4">
              <div class="flex flex-col items-center">
                <span class="text-gray-400 leading-none">Минимальная</span>
                <span class="text-rose-500 text-sm"
                  >{{ editPrice.price.minprice }} &nbsp;&#8381;</span
                >
              </div>
              <div class="flex flex-col items-center">
                <span class="text-gray-400 leading-none">Розничная</span>
                <span class="text-green-500 text-lg"
                  >{{ editPrice.price.sum }} &nbsp;&#8381;</span
                >
              </div>
              <div class="flex flex-col items-center">
                <span class="text-gray-400 leading-none">максимальная</span>
                <span class="text-sky-500 text-lg"
                  >{{ editPrice.price.maxprice }} &nbsp;&#8381;</span
                >
              </div>
            </div>

            <div class="flex flex-col my-5 items-center">
              <input
                type="text"
                class="w-1/2 bg-slate-50 h-9 px-3 py-2 v-bgray rounded-sm text-sm text-teal-700 mr-4"
                v-model="new_price"
                placeholder="Новая цена"
              />
            </div>
            <button
              class="w-max v-btn bg-green-500 hover:bg-green-400 my-2 mx-auto"
              @click="
                newBidPrice({
                  price_id: editPrice.id,
                  sum: new_price,
                }),
                  (new_price = null),
                  (s.popup = false)
              "
            >
              <span class="v-btn_text text-white">Подтвердить</span>
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ClientEdit from "../components/client/ClientEdit";
import ContactEdit from "../components/client/ContactEdit";
import CommentList from "../components/CommentList.vue";
import IcoPic from "../components/ui/IcoPic.vue";
import IcoBidStatus from "../components/ui/IcoBidStatus.vue";

const com = {
  5: true, //Звонок Исходящий
  6: true, //Письмо
  7: true, //Пришел в офис
  8: true, //Заявка через ЛК агента СРМ
  13: true, // "Заявка с сайта",
  15: true, //Звонок Входящий
};
const leadsByOther = {
  1: {
    //ПЕРВИЧНЫЙ
    1: {
      //ВХОДЯЩИЙ
      1: {
        //Интернет
        0: com /*{
                      1: true,
                      2: true,
                  }*/,
      },
      2: {
        //Рекомендация
        0: com /*{
                      4: true,
                      5: true,
                  }*/,
      },
      3: {
        //Агент
        0: com /*{
                      5: true,
                      6: true,
                      7: true,
                  }*/,
      },
    },
    2: {
      //ИСХОДЯЩИЙ
      4: {
        //Обзвон новой базы
        0: com /*{
                      5: true,
                      9: true,
                  }*/,
      },
    },
  },
  2: {
    //ВТОРИЧНЫЙ
    1: {
      //ВХОДЯЩИЙ
      21: {
        //Вторичная клиентская база
        /*1: {//Наименование клиента
                      5: true, //Звонок
                      6: true, //Письмо
                      7: true, //Пришел в офис
                      8: true, //Заявка через ЛК агента СРМ
                  },
                  6: {//Обзвон клиентов по контролю качества
                      12: true, //Заявка из отзыва с рейтингом
                  }*/
        0: com,
      },
      22: {
        //Рассылка
        /*2: {//Ниатменование рассылки
                      5: true, //Звонок
                      6: true, //Письмо
                      8: true, //Заявка через ЛК агента СРМ
                  },
                  6: {//Обзвон клиентов по контролю качества
                      12: true, //Заявка из отзыва с рейтингом
                  }*/
        0: com,
      },
      /* 23: {//Агент-сотрудник
                  3: {//ФИО агента-сотрудника
                      8: true, //Заявка через ЛК агента СРМ
                  },
                  6: {//Обзвон клиентов по контролю качества
                      12: true, //Заявка из отзыва с рейтингом
                  }
              }*/
    },
    2: {
      //ИСХОДЯЩИЙ
      21: {
        //Вторичная клиентская база
        4: {
          //Пролонгация заказа, Задача "Пролонгация"
          //5: true, //Звонок
          ...com,
        },
        5: {
          //Обзвон неактивных клиентов
          //5: true, //Звонок
          ...com,
        },
        6: {
          //Обзвон клиентов по контролю качества
          //12: true, //Заявка из отзыва с рейтингом
          ...com,
        },
      },
    },
  },
};

function extract(o, k, ...p) {
  var v = o[k];
  if (!v) {
    var s = new Set();
    Object.values(o).forEach((x) => {
      if (p.length) {
        extract(x, ...p).forEach((a) => s.add(a));
      } else {
        Object.keys(x).forEach((a) => s.add(a));
      }
    });
    return [...s];
  }
  if (p.length) return extract(v, ...p);
  else return Object.keys(v);
}
const statusClasses = {
  1: "new_lead_task",
  2: "robot_lead_task",
  3: "appoint_lead_task",
  4: "started_lead_task",
  5: "done_lead_task",
  6: "finished_lead_task",
  19: "violate_lead_task",
};
export default {
  name: "LeadEdit",

  components: { ContactEdit, CommentList, IcoPic, IcoBidStatus, ClientEdit },

  data() {
    return {
      showTouches: false,
      showLeads: false,
      showZayavka: false,
      showSchet: false,
      showAnketa: false,
      showOrder: false,
      showOrderLet: false,
      new_price: "",
      agentSum: 0,

      moment: moment,
      direction: { 1: "ВХОДЯЩИЙ", 2: "ИСХОДЯЩИЙ" },
      type: { 1: "НОВЫЙ", 2: "ВТОРИЧНЫЙ" },
      docType: "",
      docNumber: "",
      detail: {
        101: 'Задача "Как дела"',
        102: 'Задача "Пролонгация"',
        103: "Контроль качества",
        104: "Агент-сотрудник",
      },
      channel: {
        1: "Интернет",
        2: "Рекомендация",
        3: "Агент",
        4: "Обзвон новой базы",
        15: "Обзвон новой базы",
        21: "Вторичная клиентская база",
        22: "Рассылка",
        23: "Агент-сотрудник",
        //31: "Вторичная клиентская база",
      },
      cancel: {
        101: "Нецелевая заявка: другой регион",
        102: "Нецелевая заявка: б/у оборудование",
        103: "Нецелевая заявка: экономически нецелесообразно",
        104: "Нецелевая заявка: карты тахографа",
        105: "Нецелевая заявка: консультация",
        106: "Нецелевая заявка: недозвон",
        201: "Целевая заявка: дорого",
        202: "Целевая заявка: другое",
        //203: "другое",
      },
      communications: {
        1: "Интернет контекст звонок",
        2: "Интернет контекст заявка с сайта",
        3: "Интернет СЕО звонок",
        4: "Интернет СЕО заявка с сайта",
        5: "Исходящий Звонок",
        6: "Письмо",
        7: "Пришел в офис",
        8: "Заявка через ЛК агента СРМ",
        9: "Рассылка/Звонок",
        10: "Заявка через ЛК клиента в СРМ",
        11: "Заявка через ЛК агента-сотрудника",
        12: "Заявка из отзыва с рейтингом",
        13: "Заявка с сайта",
        15: "Входящий Звонок",
      },
      channelDetailType: {
        1: "Наименование клиента",
        2: "Ниатменование рассылки",
        3: "ФИО агента-сотрудника",
        4: 'Пролонгация заказа, Задача "Пролонгация"',
        5: "Обзвон неактивных клиентов",
        6: "Обзвон клиентов по контролю качества",
        7: "Интернет контекст",
        8: "Интернет СЕО",
        9: "Наименование клиента",
        10: "Наименование агента",
        11: "Вид базы",
      },
      b: {
        1: "Логистический бизнес (перевозки)",
        2: "Строительный бизнес, спецтехника",
        3: "Среднегабаритная перевозка (городские перевозки)",
        4: "Собственная доставка (свой транспортный отдел)",
        5: "Другое",
      },
      business: "",
      business_dop: "",
      ts: "",
      sum: "",
      otkaz: false,
      showCreateBid: false,
      cancel_id: 0,
      text_client: "",
      text_company: "",
      text_contact: "",
      text_price: "",
      text_comment: "",
      text_manager: "",
      explaintext: "",
      editPrice: {},
      timer: { time: null, color: null },
      companyList: [],
      contactList: [],
      priceList: [],
      managerList: [],
      st: {
        1: "новый",
        9: "назначен",
        2: "В работе",
        5: "На проверке",
        3: "Сделан счёт",
        0: "отклонен",
        8: "проверен КК",
        10: "отложен",
        4: "ОТКАЗ",
      },
      newClient: {},
      showClientEdit: false,
      statusClasses: statusClasses,
      canShowBid: false,
      canShowGar: false,
    };
  },

  computed: {
    ...mapGetters([
      "s",
      "profile",
      "role",
      "garland",
      "roles",
      "bid",
      "prices_bid",
      "firms",
      "selectBidClients",
      "selectBidCompanies",
      "selectBidContacts",
      "selectManagers",
      
    ]),
    availableChannels() {
      return extract(leadsByOther, this.bid.type, this.bid.direction);
    },

    availableChannelDetails() {
      return extract(
        leadsByOther,
        this.bid.type,
        this.bid.direction,
        this.bid.channel
      );
    },
    availableCommunicationTypes() {
      return extract(
        leadsByOther,
        this.bid.type,
        this.bid.direction,
        this.bid.channel,
        this.bid.channel_detail_type
      );
    },
    canEditClient() {
      return ["Manager", "Logist", "Studio", "Check"].includes(this.role);
    },
    canShowClient() {
      //   return [this.canEditClient, this.bid.direction, this.bid.type == 2].every(
      //     Boolean
      //   );
      return true;
    },
    canAddClient() {
      //   return [this.canEditClient, this.bid.direction, this.bid.type == 1].every(
      //     Boolean
      //   );
      return [this.canEditClient, this.bid.direction, this.bid.type == 1].every(
        Boolean
      );
    },
    canShowChannel() {
      return [
        this.bid.direction && this.bid.direction != 0,
        this.bid.type && this.bid.type != 0,
      ].every(Boolean);
    },
    canShowChannelDetailType() {
      return 21 == this.bid.channel && 2 == this.bid.direction;
    },
    canShowChannelDetailValue() {
      return ["4", "5", "6"].includes(this.bid.channel_detail_type);
    },
    canShowCommunicationType() {
      return (
        [1, 2, 3, 4, 15, 21, 22, 23].includes(this.bid.channel) &&
        this.bid.direction == 1
      );
    },
    canCloseBid() {
      var set = new Set(this.bid.tasks.map((x) => x.status));
      return ![2, 3, 4].some((x) => set.has(x));
    },
  },

  methods: {
    ...mapActions([
      "getBid",
      "setBid",
      "getGarladnsBid",
      "kindOfLead",
      "findLeadClient",
      "setBidClient",
      "delBidClient",
      "addBidClient",
      "clearLeadContactsCars",
      "setBidCompany",
      "delBidCompany",
      "setBidContact",
      "delBidContact",
      "updContact",
      "delBid",
      "setClient",
      "setClientContact",
      "showClient",
      "showContact",
      "setBidManager",
      "delBidManager",
      "setSettings",
      "addTask",
      "showTask",
      "sendCancel",
      "addOrder",
      "editOrderId",
      "setClientBusiness",
      "changeBPL",
      "setBidChannel",
      "setBidDirection",
      "setBidType",
      "setBidDetail",
      "setClientTs",
      "setBidSum",
      "setEvent1S",
      "setBidChannelDetailType",
      "setBidChannelDetailValue",
      "setBidCommunicationType",
      "addClientByLead",
      "goToTouchFromLead",
      "goToLeadFromTouch",
      "createBidFromLead",
      "getFirms",
      "setFormForBid",
      "delBidFirm",
      "getBidPrices",
      "setAgentSum",
      "sendBidCancel",
      "setBidPrice",
      "delBidPrice",
      "newBidPrice",
      "setCountBidPrice",
      "createInvoiceFromBid",
      "startBid",
      "goToInvoiceNow",
      "goToOrderNow",
      'sendAgentDocs'
    ]),

    startBidFunc() {
      this.startBid();
    },

    showCreateBidBlock() {
      if (
        (this.bid.taho == false || this.bid.taho == null) &&
        (this.bid.monitor == false || this.bid.monitor == null) &&
        (this.bid.card == false || this.bid.card == null) &&
        (this.bid.propusk == false || this.bid.propusk == null) &&
        (this.bid.teach == false || this.bid.teach == null)
      ) {
        alert("Нельзя создать заявку, так как не выбран ее тип");
        return 0;
      }
      if (this.canCloseBid) {
        this.showCreateBid = !this.showCreateBid;
      } else {
        alert("Нельзя создать заявку если задачи не завершены");
        return 0;
      }
    },
    // createBid(parent_id) {
    //   this.s.popup = null;
    //   this.createBidFromLead(parent_id);
    // },

    dClient() {
      this.contactList = null;
      this.tsList = null;
      return this.delBidClient();
    },

    close() {
      this.s.popup = null;
      this.getBid();
    },

    closeContact() {
      this.getBid();
      this.s.popup = null;
    },

    // КОМПАНИЯ
    findCompany() {
      // console.log("findCompany: ", this.text_company);
      if (this.text_company != "") {
        this.companyList = this.selectBidCompanies.filter((item) => {
          console.log("item", item);
          let name = null;
          let full = null;
          if (item.name != null) {
            name =
              item.name
                .toLowerCase()
                .indexOf(this.text_company.toLowerCase()) !== -1;
          }
          if (item.full != null) {
            full =
              item.full
                .toLowerCase()
                .indexOf(this.text_company.toLowerCase()) !== -1;
          }
          if (name || full) {
            return true;
          }
          return false;
        });
      } else {
        this.companyList = this.selectBidCompanies;
      }
    },
    async sendDocument(){
      let data = {
        id: this.bid.id,
        type: this.docType,
        number: this.docNumber
      }
      this.sendAgentDocs(data)
    },
    pickCompany(item) {
      this.setBidCompany(item);
      this.text_contact = "";
    },

    // КОНТАКТ
    findContact() {
      // console.log("findContact: ", this.text_contact);
      if (this.text_contact != "") {
        this.contactList = this.selectBidContacts.filter((item) => {
          console.log("item", item);
          let name = null;
          let secondname = null;
          if (item.name != null) {
            name =
              item.name
                .toLowerCase()
                .indexOf(this.text_contact.toLowerCase()) !== -1;
          }
          if (item.secondname != null) {
            secondname =
              item.secondname
                .toLowerCase()
                .indexOf(this.text_contact.toLowerCase()) !== -1;
          }
          if (name || secondname) {
            return true;
          }
          return false;
        });
      } else {
        this.contactList = this.selectBidContacts;
      }
    },

    findPrice() {
      // console.log("category_id ", this.cats);
      // this.priceList = this.selectPrices.filter(
      //     (item) => this.cats.includes(parseInt(item.category_id)) && item.name.toLowerCase().indexOf(this.text_price.toLowerCase()) !== -1
      // );
      this.priceList = this.prices_bid.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.text_price.toLowerCase()) !== -1
      );
    },

    pickContact(item) {
      this.setBidContact(item);
      this.text_contact = "";
    },
    toggleGarl(garlShow) {
      if (garlShow == "showTouches") {
        if (this.bid.status != 4) {
          this.showTouches = !this.showTouches;
        }
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showLeads") {
        this.showTouches = false;
        if (this.bid.status != 4) {
          this.showLeads = !this.showLeads;
        }
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showZayavka") {
        this.showTouches = false;
        if (this.bid.status != 4) {
          this.showZayavka = !this.showZayavka;
        }
        this.showSchet = false;
        this.showAnketa = false;
        this.showLeads = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showSchet") {
        this.showTouches = false;
        if (this.bid.status != 4) {
          this.showSchet = !this.showSchet;
        }
        this.showAnketa = false;
        this.showinvoice = false;
        this.showLeads = false;
        this.showZayavka = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showAnketa") {
        this.showTouches = false;
        if (this.bid.status != 4) {
          this.showAnketa = !this.showAnketa;
        }
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showinvoice = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showinvoice") {
        this.showTouches = false;
        if (this.bid.status != 4) {
          this.showinvoice = !this.showinvoice;
        }
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        this.showOrderLet = false;
      }
      if (garlShow == "showOrderLet") {
        this.showTouches = false;
        this.showinvoice = false;
        this.showLeads = false;
        this.showZayavka = false;
        this.showSchet = false;
        this.showAnketa = false;
        if (this.bid.status != 4) {
          this.showOrderLet = !this.showOrderLet;
        }
      }
    },
    showContactfromLead(contact) {
      this.s.back = "/bid/edit";
      this.setSettings(this.s);
      this.showContact(contact);
    },

    findManager() {
      this.managerList = this.selectManagers.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.text_manager.toLowerCase()) !==
          -1
      );
    },

    pickPrice(item) {
      this.setBidPrice(item);
      this.priceList = "";
      this.text_price = "";
      if (item.act == 1) {
        this.anketa = 1;
      }
      if (item.act == 2) {
        this.anketa = 2;
      }
    },

    // Order() {
    //   let formData = new FormData();
    //   formData.append("bid", this.bid.id);
    //   formData.append("client_id", this.bid.client_id);
    //   this.addOrder(formData);
    // },
   

    Tmr() {
      if (this.bid.timer) {
        let date = moment(this.bid.timer);
        let now = moment() - moment().utcOffset() * 60000 + 180 * 60000; // временная зона
        this.timer.time = moment.utc(date - now).format("HH:mm:ss");

        let t = date - now;

        if (t > 0) {
          this.timer.color = "1";
        } else {
          this.timer.color = "7";
          t = t * -1;
        }
        let hours = Math.floor(t / (1000 * 60 * 60));
        if (hours < 10) {
          hours = "0" + hours;
        }
        let minutes = Math.floor((t / (1000 * 60)) % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        let seconds = Math.floor((t / 1000) % 60);
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        this.timer.time = hours + ":" + minutes + ":" + seconds;
      } else {
        this.timer.time = null;
      }
    },

    extract: extract,
    async trySetLeadDirection(value) {
      if (value == 0) {
        await this.setClient(0);
        await this.trySetLeadChannel(0);
        await this.dClient();
      }
      await this.setLeadDirection(value);
      var channels = extract(leadsByOther, this.bid.type, this.bid.direction);
      if (channels.length === 1) await this.trySetLeadChannel(channels[0]);
      if (value == 2) await this.setLeadCommunicationType(5);
    },
    async trySetLeadType(value) {
      if (value == 0) {
        await this.setClient(0);
        //await this.trySetLeadChannel(0);
        await this.trySetLeadDirection(0);
      }
      await this.setBidType(value);
    },
    async trySetLeadChannel(value) {
      if (value == 0) {
        console.log(
          "Сбрасываем",
          this.bid.channel_detail_type,
          this.bid.channel_detail_value
        );
        -(await this.trySetLeadChannelDetailType(0));
      }
      await this.setBidChannel(value);
      if (this.bid.direction == 2) await this.setBidCommunicationType(5);
    },
    //async trySetLeadChannel(value){},
    async trySetLeadChannelDetailType(value) {
      if (value == 0) {
        console.log("Сам сброс");
        this.bid.communication_type = 0;
        this.bid.channel_detail_value = "";
        var rt = await this.setLeadCommunicationType(0);
        var rv = await this.setLeadChannelDetailValue("");
        console.log("Результаты: ", rt.data, rv.data);
      }
      await this.setLeadChannelDetailType(value);
    },
    async addNewClient() {
      var client = await this.addClientByLead();
      console.log("Новый клиент", client);
      await this.setLeadClient(client.id);
      await this.setClient(client);
      this.showClientEdit = true;
    },
    async editNewClient() {
      await this.setClient(this.bid.client);
      this.showClientEdit = true;
    },
    async clientEditClose() {
      await this.getBid();
      this.showClientEdit = false;
    },
    async trySetFirm(id) {
      await this.setFormForBid(id);
    },
    async tryDelBidFirm(id) {
      await this.delBidFirm(id);
    },

    tryCreateInvoice() {
      let formData = new FormData();
      formData.append("id", this.bid.id);
      if(this.bid.business_proc == 12 && this.bid.agent_sum == 0 )
      {
        alert("Нельзя создать счет не выставлена сумма бонуса"); return
      }
      else if (this.canCloseBid) return this.createInvoiceFromBid(formData);
      else alert("Нельзя создать счет если задачи не завершены");
    },
    tryCansel() {
      if (this.canCloseBid) this.otkaz = true;
      else alert("Нельзя оформить отказ если задачи не завершены");
    },
    // tryDelLead() {
    //   if (this.canCloseBid) return this.delLead();
    //   else alert("Нельзя удалить лид если задачи не завершены");
    // },
    tryAddTask(data) {
      if (this.canCloseBid) return this.addTask(data);
      else alert("В лиде должна быть только одна незавершенная задача");
    },
    goToTouch(touch) {
      this.goToTouchFromLead(touch);
    },
    goToLead(lead) {
      this.goToLeadFromTouch(lead);
    },
    goToInvoice(invoice) {
      this.goToInvoiceNow(invoice);
    },
    goToOrder(order) {
      this.goToOrderNow(order);
    },
    async getOneBid(){
      await this.getBid();
      this.docType = this.bid?.agent?.payment_method? this.bid?.agent?.payment_method : "",
      this.docNumber = this.bid?.agent?.value_method? this.bid?.agent?.value_method : ""
    }
  },

  mounted() {
    this.canShowBid = false;
    this.getOneBid()
    this.getGarladnsBid();
    this.getFirms();

    console.log(localStorage.getItem("bid"));

    window.setInterval(() => {
      this.Tmr();
      if (this.garland != {}) {
        this.canShowGar = true;
      }
      this.canShowBid = true;
    }, 1000);
    this.getBidPrices();
    window.DEBUG_LEAD = this;
  },
    
};
</script>
<style>
.new_lead_task {
  color: gray;
}
.robot_lead_task {
  color: blue;
}
.appoint_lead_task {
  color: green;
}
.started_lead_task {
  color: darkviolet;
}
.done_lead_task {
  color: brown;
}
.finished_lead_task {
  color: olive;
}
.violate_lead_task {
  color: red;
}
.attention {
  border-width: 2px;
  animation-duration: 0.5s;
  animation-name: alert;
  animation-iteration-count: infinite;
}
.attention:focus{
  animation: none;
}
@keyframes alert {
  0% {
    border-color: rgb(245, 245, 245);
  }
  50% {
    border-color: rgb(218, 4, 4);
    box-shadow: 3px 3px 9px rgb(218, 4, 4);
  }

  100% {
    border-color: rgb(245, 245, 245);
  }
}
</style>
